module.exports = __webpack_public_path__ + "static/img/logo.fe26ef71.png";